import React from "react";

import AssignmentIcon from "@mui/icons-material/Assignment";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import DescriptionIcon from "@mui/icons-material/Description";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import GroupsIcon from "@mui/icons-material/Groups";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import GavelIcon from "@mui/icons-material/Gavel";
import PrecisionManufacturingIcon from "@mui/icons-material/PrecisionManufacturing";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import ChangeCircleIcon from "@mui/icons-material/ChangeCircle";
import ArticleIcon from "@mui/icons-material/Article";
import FolderIcon from "@mui/icons-material/Folder";
import PercentIcon from "@mui/icons-material/Percent";
import MoneyOffIcon from "@mui/icons-material/MoneyOff";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import FindInPageIcon from "@mui/icons-material/FindInPage";
import StorageIcon from "@mui/icons-material/Storage";
import AppsIcon from "@mui/icons-material/Apps";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import SettingsIcon from "@mui/icons-material/Settings";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import StarIcon from "@mui/icons-material/Star";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import EventBusyIcon from "@mui/icons-material/EventBusy";

// Catálogo de iconos del menú: el arreglo de grupos (por ejemplo MenuCreditoArray) solo guarda la
// llave en texto, para que los datos no dependan de la librería de iconos. Una llave que no exista
// aquí cae en "generico", nunca rompe el render.
//
// Creado: 2026-09-17 — IA (Claude)
const CATALOGO_ICONOS = {
  // Grupos
  solicitudes: AssignmentIcon,
  cartera: GroupsIcon,
  facturacion: ReceiptLongIcon,
  tasas: PercentIcon,
  buro: VerifiedUserIcon,
  revision: FactCheckIcon,
  configuracion: SettingsIcon,
  otros: AppsIcon,
  recientes: AccessTimeIcon,

  // Accesos
  panel: AssignmentIcon,
  prestamo: AccountBalanceWalletIcon,
  reestructura: AutorenewIcon,
  documento: DescriptionIcon,
  cumplimiento: TaskAltIcon,
  clientes: GroupsIcon,
  transito: LocalShippingIcon,
  "cliente-nuevo": PersonAddAlt1Icon,
  "cliente-especial": StarIcon,
  juridico: GavelIcon,
  juzgado: AccountBalanceIcon,
  equipo: PrecisionManufacturingIcon,
  factura: ReceiptLongIcon,
  refactura: ChangeCircleIcon,
  pagare: ArticleIcon,
  carpeta: FolderIcon,
  porcentaje: PercentIcon,
  "tasa-cero": MoneyOffIcon,
  "documento-buscar": FindInPageIcon,
  "base-datos": StorageIcon,
  diferencias: CompareArrowsIcon,
  "diferencia-fecha": EventBusyIcon,

  generico: DescriptionIcon,
};

export const IconoMenu = ({ clave, className }) => {
  const Icono = CATALOGO_ICONOS[clave] || CATALOGO_ICONOS.generico;
  return <Icono className={className} />;
};

export default CATALOGO_ICONOS;
